<template lang="pug">
  b-container(:fluid="secondLanguage")
    tutorial-modal(view="Entrenamiento")
      template(v-slot:default)
        b-container
          p Aquí puedes entrenar a tu Chatbot para contestar las preguntas frecuentes que hacen tus clientes o información sobre tu negocio o productos.
          ul 
            li Pregunta
            p La pregunta que hará el usuario.
            li Respuesta
            p La respuesta que debe dar el Chatbot.
            li Palabras clave
            p Las palabras clave sirven para forzar o guiar al Chatbot a contestar con este entrenamiento en particular.
          b-alert(variant="info", show)
            span En el entrenamiento es indiferente el uso de signos de interrogación, acentos y/o mayúsculas
          hr
          h5 Entrenamiento para campañas
          p Si lanzas un post en Facebook y te gustaría que el Chatbot reciba un texto en específico, a continuación te mostraremos cómo entrenarlo.
          p
            b.mr-2 Ejemplo de post:
            span Por promoción navideña te damos un 20% de descuento. Mándanos un inbox con la palabra NAVIDAD20.
          p Pregunta:
          ul 
            li NAVIDAD20
          p Palabras clave:
          ul 
            li NAVIDAD20
          p Respuesta:
          ul  
            li Felicidades ya tienes un 20% de descuento. Solo presenta en recepción esta conversación.
          p.text-secondary * Adicionalmente puedes adjuntar a la respuesta una imagen, QR o PDF del cupón si lo deseas.
          b-alert(variant="warning", show) 
            span Recuerda que el entrenamiento puede tardar hasta 5 minutos en verse reflejado en el Chatbot.
    b-form-row.align-items-center.my-2
      b-col.my-1
        h4.mb-0 Entrenamiento
      b-col(cols="auto")
        b-spinner.mr-3(variant="primary", v-if="loading_question", small)
        b-button(variant="primary", @click="createQuestion", size="sm" ) Entrenar pregunta
      //b-col.my-1(cols="auto", v-if="$can('read', 'suggestion-view') || $can('read', 'knowledge-view')")
        b-dropdown(right, variant="light", :menu-class="['filters-dropdown']", no-caret)
          template(slot="button-content")
            span Inteligencia
            chevron-right-icon.icon-sm.ml-2
          b-dropdown-item(@click="$router.push({ name: 'Suggestions' })", v-if="$can('read', 'suggestion-view')")
            edit-2-icon.icon-sm.mr-2
            span Sin respuesta
            p.mb-0.text-secondary.text-sm.text-wrap Preguntas que el Chatbot no ha podido responder y puedes entrenar
          b-dropdown-item(@click="$router.push({ name: 'Knowledge' })", v-if="$can('read', 'knowledge-view')")
            book-open-icon.icon-sm.mr-2
            span Conocimento
            p.mb-0.text-secondary.text-sm.text-wrap Conocimiento aprendido de tus conversaciones previas que puedes entrenar
      b-col(cols="auto")
        b-button(variant="soft-primary", @click="testTrainingModal = true;", size="sm" ) Probar entrenamiento
      b-col(cols="auto")
        b-dropdown(right, variant="light", :menu-class="['filters-dropdown']", no-caret, size="sm" )
          template(slot="button-content")
            more-vertical-icon.icon-sm
          template(v-if="$can('read', 'advanced-training')")
            b-dropdown-item(@click="lists_modal = true", v-if="$can('read', 'training-lists')")
              .d-flex.align-items-center
                list-icon.icon-sm.mr-2
                span Editar listas
            b-dropdown-item(@click="filtersModal = true")
              .d-flex.align-items-center
                filter-icon.icon-sm.mr-2
                span Propiedades y Filtros
            b-dropdown-item(@click="upload_training_modal = true") Cargar desde archivo
            //b-dropdown-item(:href="SAM_URL + 'account/' + $route.params.account_id + '/question-blocks/download?format=csv'")
              span Descargar entrenamiento
              external-link-icon.icon-sm.ml-2
            //b-dropdown-item(:href="SAM_URL + 'account/' + $route.params.account_id + '/unanswered/download?format=csv'")
              span Descargar sugerencias
              external-link-icon.icon-sm.ml-2
            //b-dropdown-divider
          b-dropdown-item(@click="confirmSync")
            rotate-ccw-icon.icon-sm.mr-2
            span Actualizar bot
            p.mb-0.text-secondary.text-sm.text-wrap No es necesario actualizar el Bot manualmente en cambios pequeños.
    b-form-row.mb-2.align-items-center
      b-col.my-1
        b-input-group(size="sm")
          b-form-input(placeholder="Buscar por pregunta, respuesta o palabra clave...", type="search", v-model="search_text")
          b-input-group-append
            b-button(variant="soft-secondary")
              .d-flex.align-items-center
                search-icon.icon-sm
                span.ml-2(v-if="$breakpoint.mdUp") Buscar
      //- b-col(md="auto")
        b-dropdown(right, variant="soft-secondary", :menu-class="['filters-dropdown']", :no-caret="Boolean(filtersCount)")
          template(slot="button-content")
            filter-icon.icon-sm
            span.ml-1 Filtros
            span.ml-1
              b-badge(variant="primary", v-if="filtersCount") {{ filtersCount }}
          b-dropdown-header Listas
          b-dropdown-form
            treeselect(:options="parsedLists", placeholder="- Seleccionar lista -", v-model="selected_list", v-bind="treeselect_options")
    template(v-if="$can('read', 'edit-legacy-faqs')")
      question-block(v-for="question_block in questions", :key="question_block._id", v-bind="question_block", :search_text="search_text", @action:create="createAction(question_block._id)", @action:update="updateAction(question_block._id, $event)", @action:destroy="destroyAction(question_block._id, $event)", @block:update="updateQuestion(question_block._id, $event)", @block:destroy="confirmDestroyQuestion(question_block._id)")
    template(v-else)
      question-block-simple(v-for="question_block in questions", :key="question_block._id", v-bind="question_block", :search_text="search_text", @action:create="createAction(question_block._id)", @action:update="updateAction(question_block._id, $event)", @action:destroy="destroyAction(question_block._id, $event)", @block:update="updateQuestion(question_block._id, $event)", @block:destroy="confirmDestroyQuestion(question_block._id)")
    empty-message(v-if="!questions.length", message="No hay preguntas entrenadas")
    .d-flex.align-items-center
      b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getQuestionsBlocks')", v-if="v_paginationShow")
      b-spinner.ml-3(small, variant="primary", v-if="loading")
    b-modal(scrollable, title-class="w-100", v-model="lists_modal", ok-only, ok-title="Cerrar", ok-variant="secondary", size="lg")
      template(v-slot:modal-title)
        .d-flex.justify-content-between.align-items-center
          h5.mb-0 Listas
          b-button( variant="primary", @click="createList", v-if="$can('update', 'training-lists')") Crear lista
      b-row
        b-col(v-for="list in lists", :key="list.id", cols="12")
          b-card.no-shadow.bg-light
            b-form-group
              b-form-input(autocomplete="off", size="sm", placeholder="Nombre de lista", v-model="list.name", @input="updateList(list)", :disabled="!$can('update', 'training-lists')")
            b-form-group(label="Plataformas asociadas a la lista", label-size="sm")
              template(#description)
                b-link.ml-2(:disabled="!$can('update', 'training-lists')", @click="checkAllPlatforms(list)") Seleccionar todas
                b-link.text-danger.text-sm.float-right(@click="confirmDestroyList(list)")
                  trash-2-icon.icon-sm.mr-2.mb-1
                  span Eliminar Lista
              treeselect.mb-2(:options="parsedPlatforms", placeholder="- Plataformas -", v-model="list.platforms", v-bind="threeSelectOptions", :multiple="true", :clearable="false", @select="addChannel(list._id, $event)", @deselect="removeChannel(list._id, $event)", :disabled="!$can('update', 'training-lists')")
    b-modal(scrollable, footer-class="py-2", header-class="py-2", v-model="filtersModal", title="Filtros y propiedades" ok-only, ok-title="Cerrar", button-size="sm" ok-variant="secondary", size="lg")
      FiltersAndPropertiesRouter
    b-modal(title="Cargar desde archivo", v-model="upload_training_modal", ok-only, ok-title="Cerrar", ok-variant="secondary", size="lg")
      p Para cargar entrenamiento desde un archivo, debes subir un documento Excel (.xml/.xmlx) con el siguiente formato:
      ul
        li Question:
          span.text-secondary.ml-2 Las diferentes preguntas del bloque
        li Answer:
          span.text-secondary.ml-2 Las diferentes respuestas del bloque
        li Media:
          span.text-secondary.ml-2 La URL de la imagen a enviar junto con la respuesta
        li Keyword:
          span.text-secondary.ml-2 Las diferentes keywords del bloque
        li Fila vacía:
          span.text-secondary.ml-2 Indica el inicio de un nuevo bloque
      p Ejemplo de formato:
      b-table(responsive, :items="table_items", small)
        template(v-slot:cell(question)="{ item }")
          p.mb-0.text-uppercase.text-help(v-if="!item.question && !item.answer && !item.media && !item.keyword") Fila vacía
          p.mb-0(v-else) {{ item.question }}
      b-form-group(label="Subir archivo", description="Da click en Seleccionar o arrastra un archivo para subirlo")
        b-form-row.align-items-center
          b-form-checkbox(
            v-model="canSplitRows",
            :value="true",
            :unchecked-value="false"
          ).mb-2.ml-1 Dividir por filas
          b-form-checkbox(
            v-model="canOverwrite",
            :value="true",
            :unchecked-value="false"
          ).mb-2.ml-2 Sobreescribir entrenamiento
        b-form-row.align-items-center
          b-col
            b-form-file(placeholder="Selecciona un archivo en tu equipo", drop-placeholder="Suelta el archivo aquí...", v-model="upload_training_file", accept=".xls,.xlsx,.csv", browse-text="Seleccionar", :state="Boolean(upload_training_file) ? true : null")
          b-col(cols="auto")
            b-button(variant="success", :disabled="!upload_training_file", @click="uploadTrainingFile") Subir archivo

    SideModal(size="md", padding, v-model="testTrainingModal")
      template
        .test-faqs-container
          h3 Probar entrenamiento
          p.mb-2 Haz una pregunta o escribe una oración para probar qué responderá el Chatbot:
          b-form-group
            b-input-group
              b-form-input(placeholder="Escribe aquí...", @keyup.enter="testTraining", v-model="trainingText", autocomplete="off")
              b-input-group-append
                b-button(variant="soft-primary", @click="testTraining") Enviar
          .text-right.my-3.message.sent
            transition(name="slide-fade")
              div(style="max-width:75%;", v-if="sentText") {{ sentText }}
          .text-left.my-3.message.received
            transition(name="slide-fade")
              div(style="max-width:75%;", v-if="trainingAnswer && trainingAnswer.answer") {{ trainingAnswer.answer.value ? trainingAnswer.answer.value : trainingAnswer.answer || '-- Sin respuesta --' }}
          //transition(name="slide-fade")
            b-card(v-if="showTrainingCard && trainingAnswer")
              h5 Resumen de entrenamiento
              p.mb-2 Entrenamiento que coincide:

              p.text-info.mb-0 {{ trainingAnswer.answer.value ? trainingAnswer.answer.value : '-- Sin coincidencia --' }}
              p.text-secondary.text-sm {{ trainingAnswer.match && trainingAnswer.match.length ? trainingAnswer.match.join(', ') : 'Sin coincidencias con palabras clave' }}

              p.mb-1 Respuesta:
              p.text-primary {{ trainingAnswer.best_match && trainingAnswer.best_match.answer ? trainingAnswer.best_match.answer.value || '-- Sin respuesta --' : '-- Sin respuesta --' }}

              div.mb-3(v-if="trainingAnswer && trainingAnswer.actions && trainingAnswer.actions.length")
                p.mb-1 Conecta con otro bloque:
                p.text-info.mb-0 Bloque ID: {{ trainingAnswer.actions[0].payload.next_block_id }}

              p.mb-1 Certeza de similitud:
              p(:class="confidenceColor(trainingAnswer.best_match)") {{ trainingAnswer.best_match && trainingAnswer.best_match.confidence ? (trainingAnswer.best_match.confidence.toFixed(2) * 100) : 0 }}%
                b-badge.ml-2(:variant="confidenceColor(trainingAnswer.best_match) === 'text-danger' ? 'danger' : 'success'") {{ confidenceColor(trainingAnswer.best_match) === 'text-danger' ? 'No contesta' : 'Contesta' }}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import QuestionBlockSimple from '@/components/QuestionBlockSimple.vue'
import QuestionBlock from '@/components/QuestionBlock.vue'
import FiltersAndPropertiesRouter from '@/views/account/FiltersAndProperties/FiltersAndPropertiesRouter'
import _debounce from 'lodash.debounce'
import threeSelectOptions from '@/data/treeselect-options'
import { UploadFile } from '@/helpers/upload-file'
import TutorialModal from '@/components/TutorialModal.vue'

const questionController = createNamespacedHelpers('question')
const platformController = createNamespacedHelpers('platform')
const accountController = createNamespacedHelpers('account')
const listController = createNamespacedHelpers('list')
const SAM_URL = process.env.VUE_APP_SAM

export default {
  data () {
    return {
      canSplitRows: false,
      canOverwrite: false,
      testTrainingModal: false,
      trainingText: '',
      trainingAnswer: null,
      showTrainingCard: false,
      sentText: '',
      loading: false,
      lists_modal: false,
      filtersModal: false,
      plats: [],
      search_text: '',
      selected_list: null,
      threeSelectOptions,
      SAM_URL,
      loading_question: false,
      upload_training_modal: false,
      table_items: [
        {
          question: 'Hola',
          answer: 'Hola, {{ first_name }}. Estoy para ayudarte.',
          media: '',
          keyword: 'bienvenida'
        },
        {
          question: '',
          answer: 'Hola, ¿cómo te puedo ayudar?',
          media: '',
          keyword: 'saludo'
        },
        {
          question: '',
          answer: 'Hola, ¿cómo estás?',
          media: '',
          keyword: ''
        },
        {
          question: '',
          answer: '',
          media: '',
          keyword: ''
        },
        {
          question: '¿A qué hora abren?',
          answer: 'Abrimos de Lun a Dom de 9 a.m. a 7 p.m.',
          media: '',
          keyword: 'información'
        },
        {
          question: '',
          answer: 'Abrimos todos los días hasta las 7 de la noche.',
          media: '<url imagen>',
          keyword: ''
        }
      ],
      upload_training_file: null
    }
  },
  computed: {
    ...questionController.mapState({
      questions: state => state.questions
    }),
    ...accountController.mapState({
      account: state => state.account
    }),
    ...accountController.mapGetters(['selectedLanguage']),
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    ...listController.mapState({
      lists: state => state.lists
    }),
    parsedPlatforms () {
      return this.platforms.map(p => {
        return {
          label: p.title,
          id: p.name
        }
      })
    },
    parsedLists () {
      return this.lists.filter(l => Boolean(l.name)).map(l => {return {id: l._id, label: l.name}})
    },
    filtersCount () {
      let count = 0

      if (this.selected_list) {
        count ++
      }

      return count
    },
    secondLanguage () {
      return this.selectedLanguage != 1
    },
    isKonverza () {
      return (new RegExp('^konverza-', 'i')).test(this.account.type)
    },
  },
  methods: {
    ...mapActions([
      'question/all',
      'question/create',
      'question/update',
      'question/destroy',
      'question/createAction',
      'question/updateAction',
      'question/destroyAction',
      'question/sync',
      'question/load',
      'platform/all',
      'helpers/upload_file',
      'helpers/upload_private_file',
      'suggestion/sendMessage',
      'list/all',
      'list/create',
      'list/update',
      'list/destroy',
      'list/addBlock',
      'list/removeBlock',
      'list/addChannel',
      'list/removeChannel',
      'property_filter/all'
    ]),
    createQuestion () {
      let self = this
      this.loading_question = true
      let params = {
        account_id: self.$route.params.account_id,
        questions: [
          {
            value: ''
          }
        ],
        answers: [
          {
            value: ''
          }
        ],
        enabled: true
      }

      if(this.isKonverza) {
        params.lists = this.lists.map(l => l.id)
      }

      this['question/create']({
        ...params,
        callback: res => {
          self.loading_question = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    updateQuestion (id, data) {
      let self = this
      this.loading_question = true

      this['question/update']({
        account_id: self.$route.params.account_id,
        question_block_id: id,
        ...data,
        callback: res => {
          self.loading_question = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Bloque actualizado')
            let qb = self.questions.find(q => q.id == id)
            for (let key in data) {
              try {
                qb[key] = data[key]
              } catch (e) { console.error(e.message) }
            }
          }
        }
      })
    },
    confirmDestroyQuestion (id,) {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la pregunta? No se puede deshacer.`, {
        title: 'Eliminar pregunta',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      })
        .then(value => {
          if (value == true) {
            this.deleteQuestion(id)
          }
        })
        .catch(err => {})
    },
    deleteQuestion (id) {
      let self = this
      this.loading_question = true

      this['question/destroy']({
        account_id: self.$route.params.account_id,
        question_block_id: id,
        callback: res => {
          self.loading_question = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Pregunta eliminada')
          }
        }
      })
    },
    createAction (id, type = 'next_block') {
      let self = this

      this['question/createAction']({
        account_id: self.$route.params.account_id,
        type: type,
        question_block_id: id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            console.log("CREATE ACTION DONE")
            let question = self.questions.find(q => q._id == id)
            console.log("question", question)
            question.action = res.resource.action
            console.log("action", res.resource.action)
            console.log("question with action", question)
          }
        }
      })
    },
    updateAction (id, action) {
      let self = this

      this['question/updateAction']({
        account_id: self.$route.params.account_id,
        question_block_id: id,
        ...action,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let question = self.questions.find(q => q._id == id)
            question.action = res.resource.action
          }
        }
      })
    },
    destroyAction (id, action) {
      let self = this

      this['question/destroyAction']({
        account_id: self.$route.params.account_id,
        question_block_id: id,
        ...action,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let question = self.questions.find(q => q._id == id)
            question.action = null
          }
        }
      })
    },
    getPlatforms () {
      let self = this

      this['platform/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getLists () {
      let self = this
      this.loading = true

      this['list/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getFilters () {
      this.loading = true

      this['property_filter/all']({
        account_id: this.$route.params.account_id,
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
        }
      })
    },
    createList () {
      let self = this
      this['list/create']({
        account_id: self.$route.params.account_id,
        name: null,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    updateList: _debounce(function (list) {
      let self = this

      this['list/update']({
        account_id: self.$route.params.account_id,
        list_id: list._id,
        ...list,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Lista actualizada')
          }
        }
      })
    }, 1000, {leading: false, trailing: true}),
    confirmDestroyList (list) {
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la lista "${list.name}"? No se puede deshacer.`, {
        title: 'Eliminar lista',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
              this.destroyList(list)
            }
      })
    },
    destroyList (list) {
      let self = this

      this['list/destroy']({
        account_id: self.$route.params.account_id,
        list_id: list._id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Lista eliminada')
          }
        }
      })
    },
    addChannel (id, node, notify = true) {
      let self = this
      this["list/addChannel"]({
        account_id: self.$route.params.account_id,
        platform: node.id,
        list_id: id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else if(notify){
            self.$message.success('Plataforma agregada')
          }
        }
      })
    },
    removeChannel (id, node) {
      let self = this
      this["list/removeChannel"]({
        account_id: self.$route.params.account_id,
        platform: node.id,
        list_id: id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Plataforma removida')
          }
        }
      })
    },
    checkAllPlatforms ({_id, channels}) {
      for (let platform of this.parsedPlatforms) {
        if (!channels.includes(platform.id)) {
          this.addChannel(_id, platform,  false)
          channels.push(platform.id)
        }
      }
    },
    confirmSync () {
      this.$bvModal.msgBoxConfirm('El bot se actualiza automaticamente en el transcurso del día. Utiliza esta función sólo si es extremadamente necesario que se vean los cambios reflejados de inmediato en las conversaciones.', {
        title: 'Confirmar acción',
        okVariant: 'light',
        okTitle: 'Continuar',
        cancelVariant: 'danger',
        cancelTitle: 'Cancelar',
        hideHeaderClose: false
      })
      .then(value => {
        if (value === true) {
          this.syncBot()
        }
      })
      .catch(err => {
        // An error occurred
      })
    },
    syncBot () {
      let self = this
      this.showLoadingScreen()

      this['question/sync']({
        account_id: self.$route.params.account_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Bot actualizado')
            self.$bvModal.msgBoxOk('El Bot está actualizado y los cambios ya se ven reflejados en las conversaciones.', {
              okVariant: 'light',
              okTitle: 'Cerrar',
              centered: true
            })
            .then(value => {

            })
            .catch(err => {
              // An error occurred
            })
          }
        }
      })
    },
    async uploadTrainingFile () {
      try {
        const uploadedFileName = await UploadFile.call(this, this.upload_training_file, 'name', true)
        const self = this
        const { account_id: accountId } = self.$route.params

        this['question/load']({
          account_id: accountId,
          file_name: uploadedFileName,
          split_rows: self.canSplitRows,
          overwrite: self.canOverwrite,
          callback: res => {
            if (res.error) return self.$message.error(res.error)

            self.upload_training_modal = false

            this.getQuestionsBlocks()

            self.$message.success('Archivo cargado correctamente')
            self.$bvModal.msgBoxOk(`El entrenamiento se cargó correctamente.
             Refresca la página o busca los bloques con el buscador para verlos.`,
            {
              okVariant: 'light', okTitle: 'Cerrar', centered: true
            }).then(value => { }).catch(err => { console.log(err) })
          }
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async testTraining () {
      if (!this.trainingText) return

      this.sentText = ''
      this.trainingAnswer = null
      this.showTrainingCard = false

      setTimeout(() => {
        this.sentText = this.trainingText
        this['suggestion/sendMessage']({
          params: {
            text: this.sentText,
            account_id: this.$route.params.account_id,
            confidence: 0.8,
            save_faq: false,
            platform: 'messenger'
          },
          callback: res => {
            this.trainingText = ''

            if (res.error) return this.$message.error(res.error)

            this.trainingAnswer = {}

            if (res.resource) {
              const answer = res.resource
              this.trainingAnswer.answer = answer

              if (!this.trainingAnswer.answer || res.resource.message) {
                this.trainingAnswer.answer = { value: '-- Sin respuesta --' }
              }
            }

            setTimeout(() => { this.showTrainingCard = true }, 300)
          }
        })
      }, 300)
    },
    confidenceColor (best_match) {
      if (best_match.confidence && (best_match.confidence.toFixed(2) * 100) >= 80) {
        return 'text-success'
      } else {
        return 'text-danger'
      }
    },
  },
  mounted () {
    this.setPaginationLimit(10)
    this.getPlatforms()
    this.getLists()
    this.getFilters()

    if (this.secondLanguage) this.toggleSidenav('language-id-changed', 'close')

    this.getQuestionsBlocks = _debounce(() => {
      const self = this
      this.loading = true

      this['question/all']({
        account_id: self.$route.params.account_id,
        params: {
          ...self.paginationParamsObject,
          text: self.search_text || null,
          list_id: self.selected_list
        },
        callback: res => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.parsePaginationDataFromResponse(res)
        }
      })
    }, 300, { leading: false, trailing: true })

    this.getQuestionsBlocks()
  },
  components: { QuestionBlockSimple, TutorialModal, QuestionBlock, FiltersAndPropertiesRouter },
  watch: {
    search_text () {
      this.resetPaginationData()
      this.getQuestionsBlocks()
    },
    selected_list () {
      this.resetPaginationData()
      this.getQuestionsBlocks()
    },
    upload_training_modal (value) {
      if (value === false) {
        this.upload_training_file = null

        this.getQuestionsBlocks()
      }
    }
  },
  languageChanged (language_id) {
    if (language_id != 1) {
      this.toggleSidenav('language-id-changed', 'close')
    } else {
      this.toggleSidenav('language-id-changed', 'close', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.test-faqs-container {
  width: 100%;
  height: 100%;
}

.message, .message {
  div {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 1rem;
  }

  &.sent {
    div {
      background-color: #87b6fd;
    }
  }

  &.received {
    div {
      background-color: #f2f2f2;
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
